export default __webpack_public_path__ + "slices/main/assets/public/media/logo-bar-slack-white-bg@2x.436af726126278a820f713d087a8c36f.png";